import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex flex-col gap-2"
}

import { ChevronRight } from 'lucide-vue-next';
    import { Button } from '@/components/ui/button';
    import {
        Dialog,
        DialogTrigger,
        DialogContent,
        DialogHeader,
        DialogTitle,
        DialogDescription,
        DialogClose,
        DialogFooter,
        DialogBody,
    } from '@/components/ui/dialog';
    import { toast } from 'vue-sonner';
    import { useI18n } from 'vue-i18n';
    import { useMutation } from '@tanstack/vue-query';
    import { usePage } from '@inertiajs/vue3';
    import { useQueryClient } from '@tanstack/vue-query';
    import axios from 'axios';
    import QueryKey from '@/enums/QueryKey';
    import type { SharedData } from '@/types';
    import { DatePicker, Checkbox } from '@/components/ui/form';
    import { Label } from '@/components/ui/label';
    import { computed, ref } from 'vue';
    import { useDateFormat } from '@/composables/useDateFormat';
    import { today, getLocalTimeZone } from '@internationalized/date';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'VoucherReleaseAll',
  setup(__props) {

    const queryClient = useQueryClient();

    const page = usePage<SharedData>();
    const companyId = computed(() => page.props.auth.user.selected_company_id);

    const { formatDMY } = useDateFormat();

    const { t } = useI18n();

    const sendToCustomer = ref(false);
    const deadline = ref(null);
    const isOpen = ref(false);

    const { mutate, isPending } = useMutation({
        mutationFn: (formData: {
            company_id: number;
            send_to_customer: boolean;
            deadline: string | null;
        }) => axios.post(route('v2.voucher.admin.release.all'), formData),
        onSuccess: (data) => {
            queryClient.invalidateQueries({ queryKey: [QueryKey.VOUCHERS, companyId.value] });

            isOpen.value = false;
            toast.success(data.data.success);
        },
        onError: (error: any) => {
            toast.error(error.response.data.message || t('forms.system_error'));
        },
    });

function uploadAll() {
        mutate({
            company_id: companyId.value,
            send_to_customer: sendToCustomer.value,
            deadline: deadline.value,
        });
    }

    function handleCancel() {
        isOpen.value = false;
        sendToCustomer.value = false;
        deadline.value = null;
    }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Dialog), {
    open: isOpen.value,
    "onUpdate:open": _cache[2] || (_cache[2] = ($event: any) => ((isOpen).value = $event))
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(DialogTrigger), { "as-child": "" }, {
        default: _withCtx(() => [
          _createVNode(_unref(Button), {
            variant: "ghost_primary",
            width: "narrow",
            class: "self-start",
            size: "xs"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('vouchers.release')) + " ", 1),
              _createVNode(_unref(ChevronRight), { class: "text-primary" })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_unref(DialogContent), { class: "sm:max-w-lg" }, {
        default: _withCtx(() => [
          _createVNode(_unref(DialogHeader), null, {
            default: _withCtx(() => [
              _createVNode(_unref(DialogTitle), null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('vouchers.release_all.title')), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_unref(DialogBody), { class: "space-y-5" }, {
            default: _withCtx(() => [
              _createVNode(_unref(DialogDescription), null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('vouchers.release_all.content')), 1)
                ]),
                _: 1
              }),
              _createVNode(_unref(Checkbox), {
                id: "sendToCustomer",
                modelValue: sendToCustomer.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((sendToCustomer).value = $event)),
                label: "vouchers.release_all.send_to_customer"
              }, null, 8, ["modelValue"]),
              (sendToCustomer.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    _createVNode(_unref(Label), null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('vouchers.release_all.release_label')), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(DatePicker), {
                      modelValue: deadline.value,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((deadline).value = $event)),
                      label: _ctx.$t('vouchers.release_all.release_label'),
                      "min-date": _unref(today)(_unref(getLocalTimeZone)())
                    }, null, 8, ["modelValue", "label", "min-date"])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_unref(DialogFooter), { class: "gap-2 border-t sm:justify-center" }, {
            default: _withCtx(() => [
              _createVNode(_unref(DialogClose), { "as-child": "" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(Button), {
                    variant: "outline",
                    size: "sm",
                    onClick: handleCancel
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('forms.cancel')), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_unref(Button), {
                disabled: _unref(isPending) || (sendToCustomer.value && !deadline.value),
                loading: _unref(isPending),
                size: "sm",
                onClick: uploadAll
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('vouchers.release_all.button')), 1)
                ]),
                _: 1
              }, 8, ["disabled", "loading"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["open"]))
}
}

})